import { useTranslation } from "@opendash/i18n";
import { Collapse, Form } from "antd";
import dayjs from "dayjs";
import objectSupport from "dayjs/plugin/objectSupport";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { EndDatePicker, StartDatePicker, TimeSeries, useEditorItems, } from "..";
require("dayjs/locale/de");
dayjs.locale("de");
dayjs.extend(objectSupport);
/**
 * React component to create cron strings visually
 * @author Nico Vitt
 */
export const CronEditor = observer(({ value, onChange, reset, showCalendar = true, showCronString = true }) => {
    const t = useTranslation();
    const [state, editoritems] = useEditorItems({
        value: value,
        onChange: onChange,
        showCalendar: showCalendar,
        showCron: showCronString,
        reset: reset,
    });
    useEffect(() => {
        return () => {
            //Cleanup on component unmount
            state.resetState();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Form.Item, { label: t("maintenance:schedule.create.form.startdate.label"), name: "startdate", rules: [
                {
                    required: true,
                    message: t("maintenance:schedule.create.form.startdate.rules.required"),
                },
            ] },
            React.createElement(StartDatePicker, { onlyWeeks: state.onlyWeeks, setOnlyWeeks: (v) => {
                    runInAction(() => {
                        state.onlyWeeks = v;
                    });
                }, onChange: (newdate) => {
                    runInAction(() => {
                        state.startdate = newdate;
                    });
                } })),
        React.createElement(Form.Item, { label: t("maintenance:schedule.create.form.enddate.label"), name: "enddate", rules: [{ required: false }] },
            React.createElement(EndDatePicker, { onlyWeeks: state.onlyWeeks, startdate: state.startdate, onChange: (v) => (state.currentEnddate = v), disabled: state.timeSeries === "once" })),
        React.createElement(Form.Item, { label: t("maintenance:schedule.create.form.timeseries.label"), name: "timeseries", initialValue: state.timeSeries, rules: [
                {
                    required: true,
                    message: t("maintenance:schedule.create.form.timeseries.rules.required"),
                },
            ] },
            React.createElement(TimeSeries, { onlyWeeks: state.onlyWeeks, value: state.timeSeries, onChange: (value) => {
                    runInAction(() => {
                        state.timeSeries = value;
                    });
                } })),
        React.createElement(Collapse, { items: editoritems })));
});
//# sourceMappingURL=CronEditor.js.map